module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-9-b0cee199d64a646cccac0224adda52be.png";